var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForwardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11.22,
    viewBox: "0 0 12 11.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#fff;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.25 0.279)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.962,14.536H18.415l-4.7-4.705a.236.236,0,0,1,.334-.334L19.154,14.6a.226.226,0,0,1,.052.078.237.237,0,0,1-.052.258l-5.108,5.108a.233.233,0,0,1-.168.069.243.243,0,0,1-.168-.069.236.236,0,0,1,0-.334l4.706-4.705H7.962a.237.237,0,1,1,0-.474Z",
    transform: "translate(-7.725 -9.427)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardWhite);
export default __webpack_public_path__ + "static/media/arrow_forward_white.63f81f51a5396716025fdac67d9c103e.svg";
export { ForwardRef as ReactComponent };